import { Alert, Button, Card, CardBody, CardHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export function DownloadNecessaryButNoBackendAvailabilityNotification() {
  const { t } = useTranslation();
  return (
    <Card className="mt-3">
      <CardHeader>
        <h2 className={"light-header"}>
          <FontAwesomeIcon icon={faBell} /> {t("common.dataMissing")}
        </h2>
      </CardHeader>
      <CardBody>
        <Alert color="warning" fade={false}>
          {t("offline.someSongsheetsMissing")}
          <br />
          <br />
          {t("offline.checkConnection")}
          <br />
          <br />
          <Button color="primary" onClick={() => window.location.reload()}>
            {t("common.tryAgain")}
          </Button>
          <br />
          <br />
        </Alert>
      </CardBody>
    </Card>
  );
}
